const useDataLayer = () => {
  const pushEvent = eventObject => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventObject);
  };

  return [pushEvent];
};

export default useDataLayer;
